<template>
    <div class="modal-wrap">
            <div class="modal" @click.stop="">
                <header>
                    <slot name="header"></slot>
                    <i class="icon-close" @click="hideModal"></i>
                </header>
                <div class="content">
                    <slot name="content"></slot>
                </div>
                <footer>
                    <slot name="footer"></slot>
                </footer>
            </div>
    </div>
</template>

<script>
export default {
    methods: {
        hideModal () {
            this.$emit('hide-modal')
        }
    },
    mounted() {
        document.body.setAttribute('style','overflow:hidden;')
    },
    destroyed() {
        document.body.setAttribute('style','overflow:auto;')
    }
}
</script>

<style lang="scss">
.modal-wrap {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    color: #333;
    background: rgba(0, 0, 0, .4);
    z-index: 999;
    overflow: auto;
    padding: 20px;
    .modal {
        min-width: 400px;
        position: absolute;
        left: 50%;
        top: 40%;
        transform: translate(-50%, -40%);
        background: #fff;
        // border: 1px solid #ededed;
        // border-radius: 4px;
        // margin-bottom: 50px;
        header {
            height: 50px;
            line-height: 50px;
            font-size: 20px;
            margin: 0 10px;
            padding: 0 10px;
            // border-bottom: 1px solid #c7cfdd;
            i.icon-close {
                width: 14px;
                height: 14px;
                float: right;
                margin-top: 18px;
                cursor: pointer;
                background: {
                    // image: url(../../assets/images/icon-close.png);
                    repeat: no-repeat;
                    size: 100%;
                }
            }
        }
        .content {
            padding-left: 20px;
            padding-right: 20px;
        }
    }
}

</style>



// WEBPACK FOOTER //
// ModalBase.vue?7701e8ba